export const SERVICE_WORKER_PATH = '/serviceWorker.js';
export const SERVICE_WORKER_SCOPE = '/';

export const CACHE_NAMESPACE_PREFIX = 'creaticode-landing';
export const OFFLINE_FALLBACK_URL = '/offline.html';

const LEGACY_CACHE_PREFIXES = ['workbox-precache', 'lp-creaticode', 'app-creaticode', CACHE_NAMESPACE_PREFIX] as const;
const LEGACY_CACHE_NAMES = new Set(['cdn-cache', 'static-images', 'assets-files', 'static-resources', 'images', 'files']);

export function getServiceWorkerRelease() {
  return import.meta.env.VITE_APP_RELEASE;
}

export function getCurrentCacheNamespace() {
  return `${CACHE_NAMESPACE_PREFIX}-${getServiceWorkerRelease()}`;
}

export function getRuntimeMediaCacheName() {
  return `${getCurrentCacheNamespace()}-runtime-media`;
}

export function getVersionedServiceWorkerUrl() {
  const searchParams = new URLSearchParams({ release: getServiceWorkerRelease() });

  return `${SERVICE_WORKER_PATH}?${searchParams.toString()}`;
}

export function isManagedServiceWorkerScriptUrl(scriptUrl: string | null | undefined) {
  if (!scriptUrl) {
    return false;
  }

  const parsedUrl = new URL(scriptUrl, 'https://creaticode.invalid');

  return parsedUrl.pathname === SERVICE_WORKER_PATH;
}

export function shouldDeleteManagedCache(cacheName: string, keepCacheNames: ReadonlySet<string>) {
  const currentRelease = getServiceWorkerRelease();

  if (keepCacheNames.has(cacheName)) {
    return false;
  }

  if (LEGACY_CACHE_NAMES.has(cacheName)) {
    return true;
  }

  return LEGACY_CACHE_PREFIXES.some((prefix) => cacheName.startsWith(prefix)) && !cacheName.includes(currentRelease);
}